export const home = {
  title: '减少环境影响的最佳可用技术和措施',
  headerDescription:
    "在Inditex，我们致力于从根本上减少我们活动对环境的潜在影响。我们坚信，我们应该共同合作，改变我们行业的未来。这就是为什么我们与行业专家合作开发了这个工具，以支持湿法工艺的制造商（染色、印刷、洗衣和皮革相关活动）。",
  headerButton: '发现',
  techMeasuresTab: '技术与措施',
  renewableEnergyTab: '可再生能源',
  techMeasureDetail: '技术措施详情',
  footerText: '需要帮助或想分享您的反馈？',
  manufacturingProcessSelection: '制造工艺选择',
  manufacturingProcessTitle: '何种制造工艺定义了你的专业领域？',
  contactUs: '联系我们'
};